import React from 'react'
import CommonInformationList from '../../../common/pages/secure/InformationList'
import Config from '../../../Config'

class InformationList extends CommonInformationList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  onDashButtonClicked (name) {
    switch (name) {
      case 'dashboard':
        this.props.history.push('/company_user')
        break
      case 'informationList':
        this.props.history.push('/company_user/information')
        break
      case 'sharedFileList':
        this.props.history.push('/company_user/shared_files')
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span7'>
              <header className='page-header'>
                <h3>事務局からのお知らせ一覧<br />
                  <small>こちらから事務局からのお知らせを確認できます。</small>
                </h3>
              </header>
            </div>
            <div className='page-nav-options'>
              <div className='span9'>
                <ul className='nav nav-tabs'>
                  <li><a onClick={(e) => this.onDashButtonClicked('dashboard')} ><i className='icon-home' />Home</a></li>
                  <li className='active'><a className='kw-btn-success' onClick={(e) => this.onDashButtonClicked('informationList')}><i className='icon-info-sign' />お知らせ</a></li>
                  <li><a className='kw-btn-warning' onClick={(e) => this.onDashButtonClicked('sharedFileList')} ><i className='icon-file' />共有ファイル</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default InformationList



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/InformationList.js